import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  DCService
} from "../../../services/index";
import { PrintData } from "../../master/print/print";
import { bitDcPrint } from "./bitDcPrint";
declare var google;

@Component({
  selector: "bit-dc",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./bitDc.html",
})
export class bitDc implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  data: any;
  remainList: any;
  seasonList = [];
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  printData;

  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  typeList = ["OPEN", "CLOSE"];
  dctypeList = ["BULK", "BIT"];
  filter = {
    section: "",
    dc_no: "",
    dc_date: "",
    dc_type:"",
    type: "OPEN",
    finyear: "2019-2020",
    design_no: "",
    wo_no: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "dc_no",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("printTemplate") printTemplate: TemplateRef<any>;
  @ViewChild("InwTemplate") InwTemplate: TemplateRef<any>;
  @ViewChild("stkTemplate") stkTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  dcdata: any = [];
  dcdata1: any;

  constructor(
    public store: Store<fromRootStore.State>,
    public dcservice: DCService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private modalService: BsModalService,
    public toasterService: ToasterService
  ) { }

  ngOnInit(): void {
    this.finyearCombo();
    this.toggleCol = Object.assign({}, this.columns);
    this.data = {
      dcdata: [],
      dcdata1: [],
    };
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Dc No",
        prop: "dc_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Dc Date",
        prop: "fdate",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Dc Type",
        prop: "dc_type",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Unit",
        prop: "unit",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Brand",
        prop: "brand",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Style",
        prop: "style",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Tot.Mtr",
        prop: "total_mtr",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Width",
        prop: "main_width",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Size",
        prop: "size",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,

      },
      {
        name: "Action",
        prop: "sno",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },
      {
        name: "Print",
        prop: "sno",
        headerClass: "text-center",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        sortable: false,
        cellTemplate: this.printTemplate,
      },
   
    ];
    if(this.filter.type == "OPEN"){
      
      let obj1 = {
        name: "Add Inward",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        cellClass: "text-center",
        sortable: false,
        cellTemplate: this.InwTemplate,
        
      };

     let obj2 =
      {
        name: "Close DC",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        cellClass: "text-center",
        sortable: false,
        cellTemplate: this.stkTemplate,
        
      };
     this.columns.push(obj1);
     this.columns.push(obj2);
    
    }
    // else if(this.filter.type == "CLOSE"){
  
    //   // this.columns = this.columns.filter(el => el.name !== "Add Inward");
    
    //   let obj = {
    //     name: "Add Stock",
    //     prop: "sno",
    //     minWidth: 80,
    //     maxWidth: 80,
    //     width: 80,
    //     cellClass: "text-center",
    //     sortable: false,
    //     cellTemplate: this.stkTemplate,
    //   };
    // this.columns.push(obj);

    // }
    this.toggleCol = Object.assign({}, this.columns);
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#section").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getDcList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.section = "";
    this.filter.type = "";
    this.filter.dc_type = "";
    this.filter.dc_date = "";
    this.filter.dc_no = "";
    this.filter.wo_no = "";
    this.filter.design_no = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getDcList();
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.filter.finyear = res.data[0].finyear;
      this.pageCallback({ offset: 0 });

    });
  }
  getDcList(): void {
    if (this.filter.dc_date == "") {
      this.filter.dc_date == "";
    } else {
      this.filter.dc_date = this.datePipe.transform(
        this.filter.dc_date,
        "yyyy-MM-dd"
      );
    }
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      dc_no: this.filter.dc_no,
      type: this.filter.type,
      dc_type: this.filter.dc_type,
      dc_date: this.filter.dc_date,
      finyear: this.filter.finyear
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.dcservice.bitDCList(params).then(function (res: any) {
      that.loadingIndicator = false;
      that.page.count = res.totCnt;
      that.dcdata = res.data;
      that.getColumns();
    
    });
  }
  CloseInw(row: any): void {
    row.tabevent = undefined;
    let that = this;
    let params = {
     dc_id : row.dc_id
    }
    swal({
      title: "Are you sure to Close this DC?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        that.isLoadMask = that.dcservice
          .CloseInw(params)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.getDcList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "success";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {}
    );
  }
  addEditDC(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getDcList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          tabName: "ADD JOB WORK DC",
          title: "ADD JOB WORK DC",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "addEditBitDc",
        },
      };
    } else if (mode == "Edit") {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "EDIT JOB WORK DC",
          title: "EDIT JOB WORK DC",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "addEditBitDc",
        },
      };
    }
    else if (mode == "Inward") {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "ADD JOBDC INWARD",
          title: "ADD JOBDC INWARD",
          tabParent: "SALES_PLAN",
          mode: mode,
          data: row,
          name: "ADD JOBDC INWARD",
        },
      };
    }  
    else {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "VIEW JOB WORK DC",
          title: "VIEW JOB WORK DC",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "addEditBitDc",
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }
  // addEditBrandStock(mode: string, row: any): void {
  //   let listUpdateEvent = new EventEmitter();
  //   listUpdateEvent.subscribe(() => {
  //     this.getDcList();
  //   });
  //   row.tabevent = listUpdateEvent;
  //   let tabObj = {};
  //   if (mode == "Add") {
  //     tabObj = {
  //       action: "NewTab",
  //       params: {
  //         //  tabParent: 'Transaction',
  //         tabName: "ADD BRAND STOCK INWARD",
  //         title: "ADD BRAND STOCK INWARD",
  //         tabParent: "SALES_PLAN",
  //         mode: mode,
  //         data: row,
  //         name: "ADD BRAND STOCK",
  //       },
  //     };
  //   }
  // deleteDC(row: any): void {
  //   row.tabevent = undefined;
  //   let that = this;
  //   swal({
  //     title: "Are you sure to delete this DC Details?",
  //     text: "You will not be able to recover this DC" + " " + row["dc_no"] + "",
  //     type: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes, delete it!",
  //     cancelButtonText: "No, keep it",
  //   }).then(
  //     function () {
  //       that.isLoadMask = that.dcservice
  //         .deleteDC(row)
  //         .then(function (res: any) {
  //           that.loadingIndicator = false;
  //           that.getDcList();
  //           let errtype = "success",
  //             errmsg = res.message;
  //           if (!res.success) {
  //             errtype = "error";
  //           }

  //           that.toasterService.pop({
  //             bodyOutputType: 1,
  //             type: errtype,
  //             title: errtype.toUpperCase(),
  //             body: errmsg,
  //           });
  //         });
  //     },
  //     function (dismiss) {}
  //   );
  // }
  bsModalRef: BsModalRef;
  printDc(row) {
    this.bsModalRef = this.modalService.show(bitDcPrint, {
      keyboard: false,
      ignoreBackdropClick: true,
      class: "modal-lg compWidth-96"
    });
    this.bsModalRef.content.printdt = Object.assign({}, row);
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/bitDc/bitDc.ts